import { render } from "./Opciones.vue?vue&type=template&id=58a21168&scoped=true"
import script from "./Opciones.vue?vue&type=script&lang=js"
export * from "./Opciones.vue?vue&type=script&lang=js"

import "./Opciones.vue?vue&type=style&index=0&id=58a21168&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a21168"]])

export default __exports__